import { Icon } from 'antd'

export default Icon



// WEBPACK FOOTER //
// ./src/elements/icon/index.js